var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stepper-box" }, [
    _c("div", { staticClass: "top" }, [
      _c("div", {
        staticClass: "divider-line",
        style: {
          width: (100 / _vm.steps.length) * (_vm.steps.length - 1) - 10 + "%"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "steps-wrapper" },
        [
          _vm._l(_vm.steps, function(step, index) {
            return [
              _c(
                "div",
                {
                  key: index,
                  class: ["step", _vm.isStepActive(index)],
                  style: { width: 100 / _vm.steps.length + "%" }
                },
                [
                  _c("div", { staticClass: "circle" }, [
                    _c(
                      "div",
                      {
                        class: [
                          !step.valid ? "icon border border-danger" : "icon"
                        ]
                      },
                      [
                        !step.valid
                          ? _c("font-awesome-icon", {
                              staticClass: "text-danger",
                              attrs: { icon: ["fad", "exclamation"] }
                            })
                          : step.completed
                          ? _c("font-awesome-icon", {
                              style: { color: "#28A745" },
                              attrs: { icon: ["far", "check"] }
                            })
                          : _c("font-awesome-icon", {
                              attrs: { icon: ["fad", step.icon] }
                            })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step-title" }, [
                    _c(
                      "h5",
                      { class: [!step.valid ? "icon text-danger" : ""] },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(step.title) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("h4", { staticClass: "text-center" }, [
          _vm._v(_vm._s(_vm.steps[_vm.currentStep.index].subtitle))
        ]),
        _vm._v(" "),
        _vm._t("default")
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { class: ["bottom", _vm.currentStep.index > 0 ? "" : "only-next"] },
      [
        _vm.currentStep.index > 0
          ? _c(
              "div",
              {
                staticClass: "stepper-button previous",
                on: {
                  click: function($event) {
                    return _vm.backStep()
                  }
                }
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-dark",
                    attrs: { type: "button" }
                  },
                  [_vm._v("Vorige")]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showCancel
          ? _c(
              "button",
              {
                staticClass: "btn btn-warning next",
                on: {
                  click: function($event) {
                    return _vm.cancelStepper()
                  }
                }
              },
              [_c("span", [_vm._v("Annuleren")])]
            )
          : _vm.finalStep && !_vm.isFormChanged
          ? _c(
              "button",
              {
                staticClass: "btn btn-warning next mr-2",
                on: {
                  click: function($event) {
                    return _vm.cancelStepper()
                  }
                }
              },
              [_vm._m(0)]
            )
          : _c(
              "button",
              {
                staticClass: "btn btn-primary next",
                attrs: { disabled: !_vm.canContinue },
                on: {
                  click: function($event) {
                    return _vm.nextStep()
                  }
                }
              },
              [
                !_vm.finalStep
                  ? _c("span", [_vm._v("Volgende")])
                  : _c("span", [_vm._v("Versturen")])
              ]
            )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("span", [_vm._v("Wizard overslaan")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }